import { Injectable } from '@angular/core';
import { EnvironmentsEnum } from '../../enum/environments-enum';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class EnvironmentCssClassesGeneratorService {
    constructor() {}

    get serviceNoticeClasses(): any {
        const smallWidthRightSide: string[] = [
            EnvironmentsEnum.DEFAULT,
            EnvironmentsEnum.JUSTICE,
            EnvironmentsEnum.FINANCE,
            EnvironmentsEnum.SH,
            EnvironmentsEnum.HMDJ,
            EnvironmentsEnum.BB_JM,
        ];

        const classList = {
            'col-12': true,
            'col-sm-6': false,
            'offset-0': false,
            'offset-sm-6': false,
        };

        if (smallWidthRightSide.includes(environment.deploy_environment)) {
            classList['col-sm-6'] = true;
            classList['offset-0'] = true;
            classList['offset-sm-6'] = true;
        }

        return classList;
    }
}
